import { CircleHelp, Mail } from "lucide-react";
import { PageHeader } from "@/pages/Kennisbank";

// FAQ-items: hier later de meest gestelde pilotvragen toevoegen als { vraag, antwoord }.
// Zolang de lijst leeg is, toont de pagina alleen de introductie en het contactblok.
const FAQ_ITEMS = [];

export default function FaqContact() {
  return (
    <div className="animate-fade-up">
      <PageHeader title="FAQ & Contact" icon={CircleHelp}
        subtitle="Antwoorden op veelgestelde vragen over Zoetwaren Kompas. Staat je vraag er niet bij? Neem dan contact met ons op." />

      <div className="max-w-3xl space-y-6">
        {FAQ_ITEMS.length === 0 ? (
          <p data-testid="faq-intro" className="text-sm text-slate-600 border border-dashed border-slate-300 rounded-lg p-6">
            De meest gestelde vragen uit de pilot verschijnen hier binnenkort. Heb je nu al een
            vraag? Gebruik <span className="font-medium text-[#8a5a20]">Stel een vraag</span> op
            het startscherm, of mail ons via het contactblok hieronder.
          </p>
        ) : (
          <div data-testid="faq-lijst" className="space-y-3">
            {FAQ_ITEMS.map((item, i) => (
              <details key={i} data-testid={`faq-item-${i}`}
                className="zk-card bg-white border border-slate-200 rounded-lg p-4 group">
                <summary className="font-heading font-semibold text-slate-900 cursor-pointer list-none flex items-center justify-between gap-3">
                  {item.vraag}
                  <span className="text-[#B9772B] transition-transform group-open:rotate-180">⌄</span>
                </summary>
                <p className="text-sm text-slate-700 leading-relaxed mt-3">{item.antwoord}</p>
              </details>
            ))}
          </div>
        )}

        <div data-testid="faq-contactblok"
          className="bg-[#FDF8EE] border border-[#EBD9BC] rounded-lg p-5 sm:p-6 space-y-3">
          <div className="flex items-center gap-2.5">
            <span className="w-8 h-8 rounded-xl bg-[#B9772B] flex items-center justify-center shrink-0">
              <Mail className="w-4 h-4 text-white" />
            </span>
            <h2 className="font-heading text-lg font-bold text-[#3A281B]">Contact</h2>
          </div>
          <p className="text-sm text-slate-700 leading-relaxed">
            Staat je vraag er niet bij, zie je een fout of wil je feedback geven?
          </p>
          <a data-testid="faq-contact-mail" href="mailto:contact@zoetwarenkompas.nl"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#8a5a20] underline underline-offset-4 decoration-[#D8BE95] hover:decoration-[#B9772B] break-all">
            <Mail className="w-4 h-4 shrink-0" /> contact@zoetwarenkompas.nl
          </a>
        </div>
      </div>
    </div>
  );
}
